<template>
    <div>
         <template v-for="DATA_IDLAB in dataGroupByIdlab">
     <span :key="DATA_IDLAB.idlab"> 
       <div class="box mb-5">
            

           <article class="media">
                    <div class="media-content">
                        <div class="content  is-size-7">
                                <!-- LAB ID. : <span class="has-text-grey has-text-weight-semibold">   {{DATA_IDLAB.idlab}}  </span>  <br> -->
                                <span class="has-text-grey control"> 
                                        <b-tooltip position="is-top" multilined>
                                        <template v-slot:content>
                                               View <b>{{DATA_IDLAB.idlab}}</b><br/> Full Content Data
                                        </template>
                                        <b-button size="is-small"
                                            icon-left="github-circle"
                                            @click="showLab(DATA_IDLAB.idlab,DATA_IDLAB.data[0].lab_kind_name,DATA_IDLAB.data[0].idopd)" >
                                        {{DATA_IDLAB.idlab}} 
                                        </b-button> 
                                        </b-tooltip>
                                        <span class="control">
                                               <b-tooltip position="is-top" multilined type="is-white">
                                               <template v-slot:content>
                                               Copy <b>{{DATA_IDLAB.idlab}}</b><br/> clipboard
                                               </template>
                                              <b-button  size="is-small"  icon-left="content-copy" v-clipboard:copy="DATA_IDLAB.idlab" @click="clickCopyIntoClipboard(DATA_IDLAB.idlab)" />
                                              </b-tooltip>
                                         </span>
                                </span>  <br/> 
                                OPD No.: <span class="has-text-grey">   {{DATA_IDLAB.data[0].idopd}}   </span>  <br>
                                OPD Name : <span class="has-text-grey">   {{DATA_IDLAB.data[0].opd_name}}  </span>  <br>
                                Species/Breed : <span class="has-text-grey">   {{DATA_IDLAB.data[0].species_name}}  /  {{DATA_IDLAB.data[0].breed_name}}  </span>  <br>
                                By : <span class="has-text-grey">   {{DATA_IDLAB.data[0].user_rec_fn}}     </span>  <br>
                             
                                At : <span class="has-text-grey mb-3">        <span  >
                                                                            {{  getISO8601ToYearMonthDate( DATA_IDLAB.data[0].datetime_rec ).date }}  
                                                                            {{  getISO8601ToYearMonthDate( DATA_IDLAB.data[0].datetime_rec  ).month }} 
                                                                            {{  getISO8601ToYearMonthDate( DATA_IDLAB.data[0].datetime_rec   ).year }} 
                                                                         </span> 
                                                                                
                                                                         <span  >
                                                                                {{  getISO8601ToYearMonthDate( DATA_IDLAB.data[0].datetime_rec  ).hour }}:{{  getISO8601ToYearMonthDate(  DATA_IDLAB.data[0].datetime_rec ).minute }} 
                                                                         </span>  
                                    </span>  <br>
                                   <template  >
                                    <div class="box mb-3 mt-3"  v-for="DX in DATA_IDLAB.data[0].dx" :key="DX.id">
                                        <span v-if="DX.unclassified_codes != null"  >Dx Unclassified :  <span class="has-text-grey">{{DX.unclassified_codes}}</span>   <br></span>
                                        <span v-if="DX.hierarchy != null" >Dx Hierarchy : <span class="has-text-grey"> {{DX.hierarchy}}</span>   </span>
                                    </div>
                                </template>  
                        </div>
                    </div>
                </article>




        <div class="columns is-multiline"    >
            <div class="column is-one-quarter-desktop is-half-tablet"   v-for="DATA_IMG in DATA_IDLAB.data " :key="DATA_IMG.id"    >
                <div  class="card" >
                    <div class="card-image  ">
                        <figure class="image is-4by3"  >
                        <img :src="buildFullImageUrl_FromIDLABAndPath(DATA_IDLAB.idlab,DATA_IMG.path)"  >
                        </figure>
                    </div>
                    <footer class="card-footer">
                        <a class="card-footer-item"  @click="imageModal(buildFullImageUrl_FromIDLABAndPath(DATA_IDLAB.idlab,DATA_IMG.path))"  >
                            <b-icon
                                    icon="magnify"
                                    size="is-medium">
                            </b-icon>
                        </a>
                    </footer>
                </div>
            </div>
        </div>
       </div>
      
      
        
      
       </span> 
          

   </template>
      <b-button type="is-primary" outlined 
                        :loading="isMoreBtnLoadingModel" 
                        class="ml-5 mt-5 mb-5"
                        @click="loadDataMore" >More..</b-button> 
 


         <b-modal :active.sync="isImageModalActive">
            <p class="image ">
                <img :src=dataUrl>
            </p>
        </b-modal>
    </div>
</template>


<script>
import {mapMutations, mapState } from "vuex";
import _ from 'lodash'
import getISO8601ToYearMonthDate from '../mixins/methods/getISO8601ToYearMonthDate'
import buildFullImageUrl_FromIDLABAndPath from '../mixins/methods/buildFullImageUrl_FromIDLABAndPath'

export default {
    name: "ImagesLABNonRecently_ViewGrpIDLab",
    mixins:[getISO8601ToYearMonthDate,buildFullImageUrl_FromIDLABAndPath,],
    computed:{
        ...mapState({
            imagesArrRecently : state => state.home.imagesArrRecently ,
            isMoreBtnLoading : state => state.home.isMoreBtnLoading ,
        }),
        dataGroupByIdlab(){

         return    _(this.imagesArrRecently)
                    .groupBy(x => x.idlab)
                    .map((value, key) => ({idlab: key, data: value}))
                    .value();
    
        },
        isMoreBtnLoadingModel:{
                get: function () {
                    return this.isMoreBtnLoading
                },
                set: function (newValue) {
                    this.setIsMoreBtnLoading(newValue)
                }
        }, 
    },
    methods:{
         ...mapMutations({
            setIsMoreBtnLoading : 'home/setIsMoreBtnLoading',
        }),
        loadDataMore(){
            this.isMoreBtnLoadingModel = true
            this.$emit('loadMoreDataImagesRecently')
        },
        imageModal(dataUrl){
                if(dataUrl !== "") {
                    this.dataUrl = dataUrl
                }else{
                    this.dataUrl = 'imgnotaval.jpg'
                }
                this.isImageModalActive = true
        },
        showLab(_idlab,_kind,_idopd){
            const payload =  {"idlab": _idlab ,"kind": _kind ,"idopd":_idopd} 
            this.$emit('showLab',payload)
        },
        clickCopyIntoClipboard(_id){
              this.$buefy.toast.open({
                    duration: 2000,
                    message: `Copy <b>${_id}</b> to clipboard`,
                    position: 'is-bottom',
                    type: 'is-primary is-light'
                })
        },
     
    },
    data(){
        return{
            //   isMoreBtnLoading : false,


              isImageModalActive : false,
              dataUrl : "",
        }
    }
}
</script>